import { Suspense, type PropsWithChildren } from 'react'

import { PageLayoutSkeleton } from '@/layouts/page'

import { ConfiguracoesReservaSkeleton } from './configuracoes-reserva.skeleton'

export const ConfiguracoesReservaPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <ConfiguracoesReservaSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
